import ChartInspectionsByStatus from "@/components/Dashboard/ChartInspectionsByStatus";
import ChartInspectionsByCompany from "@/components/Dashboard/ChartInspectionsByCompany";
import ChartInspectionsByCountry from "@/components/Dashboard/ChartInspectionsByCountry";

import '../../components/Dashboard/dashboard.css'
import ChartInvoicesInspectingCompany from "@/components/Dashboard/ChartInvoicesInspectingCompany";
import ChartSireReviewResults from "@/components/Dashboard/ChartSireReviewResults";
import ChartSireReviewByRequestor from "@/components/Dashboard/ChartSireReviewByRequestor";
import ChartInvoicesShipOperator from "@/components/Dashboard/ChartInvoicesShipOperator";
// import ChartInspectionsByMarket from "@/components/Dashboard/ChartInspectionsByMarket";
import ChartInspectionsByInspector from "@/components/Dashboard/ChartInspectionsByInspector";
import ChartInspectionsStatusByMarket from "@/components/Dashboard/ChartInpectionsStatusByMarket";
import IncomeExpenseDisplay from "@/components/Dashboard/IncomeExpenseDisplay";
import { SERVICES } from "@/common/constants";
import ChartInspectionsByOperatorByCountry from "@/components/Dashboard/ChartInspectionsByShipOperatorByCountry";

const Dashboard = (): JSX.Element => {

    return (
        <div>
            <div className="dashboard-row">
                <IncomeExpenseDisplay type={SERVICES.INSPECTION} />
            </div>
            <div className="dashboard-row">
                <IncomeExpenseDisplay type={SERVICES.SIRE_REVIEW} />
            </div>
            <div className="dashboard-row" style={{display: 'flex', gap: '0', width: '100%' }}>
                <ChartInspectionsByStatus />
            </div>
            <div className="dashboard-row">
                <ChartInspectionsStatusByMarket />
            </div>
            <div className="dashboard-row" style={{display: 'flex', gap: '0'}}>
                <ChartInvoicesInspectingCompany />
                <ChartInvoicesShipOperator />
            </div>
            <div className="dashboard-row" style={{display: 'flex', gap: '0'}}>
                <ChartInspectionsByCompany />
                <ChartInspectionsByInspector />
            </div>
            <div className="dashboard-row">
                <ChartSireReviewResults />
                <ChartSireReviewByRequestor />
            </div>
            <ChartInspectionsByOperatorByCountry />
            <ChartInspectionsByCountry />
        </div>
    )
};

export default Dashboard;
